import { render } from "./BaseFormComponent.vue?vue&type=template&id=399cd7c0"
import script from "./BaseFormComponent.vue?vue&type=script&lang=js"
export * from "./BaseFormComponent.vue?vue&type=script&lang=js"

import "./BaseFormComponent.vue?vue&type=style&index=0&id=399cd7c0&lang=css"

import exportComponent from "/builds/fLte45evJ/0/trinax/jeopardy.trinax.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__